module.exports = __webpack_public_path__ + "img/email-verify.5b88e3c7.png";